// Defines log levels
export var Level;
(function (Level) {
    Level[Level["Emergency"] = 0] = "Emergency";
    Level[Level["Alert"] = 1] = "Alert";
    Level[Level["Critical"] = 2] = "Critical";
    Level[Level["Error"] = 3] = "Error";
    Level[Level["Warning"] = 4] = "Warning";
    Level[Level["Notice"] = 5] = "Notice";
    Level[Level["Info"] = 6] = "Info";
    Level[Level["Debug"] = 7] = "Debug";
})(Level || (Level = {}));
/**
 * Helps in logging information.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class Logger {
    /**
     * Prints a log message, if debugging is enabled.
     *
     * @param {string} context Message context
     * @param {Level} [level] Log level
     * @param {any[]} message Message to log
     * @returns {void}
     */
    static log(context, level = Level.Emergency, ...message) {
        if (!A11yConsentConfiguration.settings.settings.debug.enabled) {
            return;
        }
        let targetLevel = Level.Emergency;
        if (A11yConsentConfiguration.settings.settings.debug.level) {
            targetLevel = parseInt(Level[A11yConsentConfiguration.settings.settings.debug.level].valueOf());
        }
        if (targetLevel >= level) {
            switch (level) {
                case Level.Emergency:
                    console.log(`%c[${context}]`, 'color: #ff0000; font-weight: bold;', ...message);
                    break;
                case Level.Alert:
                    console.log(`%c[${context}]`, 'color: #eb0000; font-weight: bold;', ...message);
                    break;
                case Level.Critical:
                    console.log(`%c[${context}]`, 'color: #d80000; font-weight: bold;', ...message);
                    break;
                case Level.Error:
                    console.log(`%c[${context}]`, 'color: #c40000; font-weight: bold;', ...message);
                    break;
                case Level.Warning:
                    console.log(`%c[${context}]`, 'color: #ffa500; font-weight: bold;', ...message);
                    break;
                case Level.Notice:
                    console.log(`%c[${context}]`, 'color: #1414ff; font-weight: bold;', ...message);
                    break;
                case Level.Info:
                    console.log(`%c[${context}]`, 'color: #0aff0a; font-weight: bold;', ...message);
                    break;
                case Level.Debug:
                    console.log(`%c[${context}]`, 'color: #ff76ff; font-weight: bold;', ...message);
                    break;
            }
        }
    }
    static emergency(context, ...message) {
        Logger.log(context, Level.Emergency, ...message);
    }
    static alert(context, ...message) {
        Logger.log(context, Level.Alert, ...message);
    }
    static critical(context, ...message) {
        Logger.log(context, Level.Critical, ...message);
    }
    static error(context, ...message) {
        Logger.log(context, Level.Error, ...message);
    }
    static warning(context, ...message) {
        Logger.log(context, Level.Warning, ...message);
    }
    static notice(context, ...message) {
        Logger.log(context, Level.Notice, ...message);
    }
    static info(context, ...message) {
        Logger.log(context, Level.Info, ...message);
    }
    static debug(context, ...message) {
        Logger.log(context, Level.Debug, ...message);
    }
    static trace(context) {
        if (!A11yConsentConfiguration.settings.settings.debug.enabled) {
            return;
        }
        console.trace(context !== null && context !== void 0 ? context : 'trace');
    }
}
